import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { routes } from "../../constants";
import { useStore } from "../../contexts";
import { selectors } from "../../store/state-selectors";

/**
 * Prevents access to the page if the user is a partially onboarded vendor (does not have a business).
 */
export function withBlockPartiallyOnboardedVendor(Component) {
  return function WithBlockPartiallyOnboardedVendor(props) {
    const location = useLocation();
    const businessId = useStore(selectors.user.businessId);
    const userId = useStore(selectors.user.id);
    const isPartiallyOnboardedVendor = !!userId && !businessId;
    const defaultRouteForVendor = routes.defaultAuthorizedRoute(true);
    return isPartiallyOnboardedVendor ? location.pathname === defaultRouteForVendor ? /*#__PURE__*/React.createElement("div", {
      "data-testid": "blocked-partially-onboarded-vendor"
    }) : /*#__PURE__*/React.createElement(Redirect, {
      to: {
        pathname: defaultRouteForVendor,
        search: location.search
      }
    }) : /*#__PURE__*/React.createElement(Component, props);
  };
}